// src/components/About.js
import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';

const ResidentialRent = () => {
  const steps = ['Basic Details', 'Property Details', 'Price Details', 'Review & Submit'];
  const [activeStep, setActiveStep] = useState(0);
  const [error, setError] = useState("");
  

  // State to store form data for all steps
  const [formData, setFormData] = useState({
    basicDetails: { type: 'residential', service: 'rent', address: '' },
    propertyDetails: {
      property_type: '', building: '', locality: '', furnish_type: '',
      bhk: '', builtup: ''
    },
    propertyPrice: {
      monthlyRent: '', availableForm: '', securityDeposit: ''

    },
  });

  const [errors, setErrors] = useState({});

  const handleInputChange = (step, field, value) => {
    setFormData((prev) => ({
      ...prev,
      [step]: {
        ...prev[step],
        [field]: value,
      },
    }));
    setErrors((prev) => ({
      ...prev,
      [field]: '', // Clear error for the field being modified
    }));
  };

  const validateStep = () => {
    const newErrors = {};
    if (activeStep === 0) {
      if (!formData.basicDetails.type) newErrors.type = "Property type is required.";
      if (!formData.basicDetails.service) newErrors.service = "Service type is required.";
      if (!formData.basicDetails.address.trim()) newErrors.address = "Address is required.";
    }
    if (activeStep === 1) {
      if (!formData.propertyDetails.property_type) newErrors.property_type = "Property type is required.";
      if (!formData.propertyDetails.building.trim()) newErrors.building = "Building/Project/Society is required.";
      if (!formData.propertyDetails.locality.trim()) newErrors.locality = "Locality is required.";
      if (!formData.propertyDetails.furnish_type) newErrors.furnish_type = "Furnish type is required.";
      if (!formData.propertyDetails.share_listing) newErrors.share_listing = "Share Listing is required.";
      if (['independent_floor', 'independent_house', 'villa'].includes(formData.propertyDetails.property_type)) {
        if (!formData.propertyDetails.builtup.trim()) {
          newErrors.builtup = "Build Up is required.";
        }
        if (!formData.propertyDetails.bhk) {
          newErrors.bhk = "BHK is required.";
        }
      }


    }
    if (activeStep === 2) {
      if (!formData.propertyPrice.monthlyRent.trim()) newErrors.monthlyRent = "Monthly Rent is required.";
      if (!formData.propertyPrice.availableForm) newErrors.availableForm = "Available Form Date  is required.";
      if (!formData.propertyPrice.securityDeposit) newErrors.securityDeposit = "Security Deposit Type is required.";
    }
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleNextStep = () => {
    if (validateStep()) {
      setActiveStep((prev) => prev + 1);
    }
  };

  const handleSubmit = async (e) => {
    //alert(JSON.stringify(formData));  
    e.preventDefault();
    try {
      const response = await axios.post(`${process.env.REACT_APP_BASE_URL}/residentialRent`,formData, {
      });   
      console.log('API Response:', response.data);
  } catch (error) {
      console.error("Property Add error:", error);
      setError("An error occurred. Please try again later.");
  }
};


  const renderStepContent = (step) => {
    switch (step) {
      case 0:
        return (
          <div>
            <div className="mb-3">
              <label className="form-label">Property Type</label>
              <div className="btn-group" role="group">
                <button
                  type="button"
                  className={`btn ${formData.basicDetails.type === 'residential' ? 'btn-primary' : 'btn-outline-primary'}`}
                  onClick={() => handleInputChange('basicDetails', 'type', 'residential')}
                >
                  Residential
                </button>
                <Link to="/commercialRent">
                <button
                  type="button"
                  className={`btn ${formData.basicDetails.type === 'commercial' ? 'btn-primary' : 'btn-outline-primary'}`}
                  onClick={() => handleInputChange('basicDetails', 'type', 'commercial')}
                >
                  Commercial
                </button>
                </Link>
              </div>
              {errors.type && <small className="text-danger">{errors.type}</small>}
            </div>

            <div className="mb-3">
              <label className="form-label">Looking to</label>
              <div className="btn-group" role="group">
                <button
                  type="button"
                  className={`btn ${formData.basicDetails.service === 'rent' ? 'btn-primary' : 'btn-outline-primary'}`}
                  onClick={() => handleInputChange('basicDetails', 'service', 'rent')}
                >
                  Rent
                </button>
                <Link to="/residentialSell">
                <button
                  type="button"
                  className={`btn ${formData.basicDetails.service === 'sell' ? 'btn-primary' : 'btn-outline-primary'}`}
                  onClick={() => handleInputChange('basicDetails', 'service', 'sell')}
                >
                  Sell
                </button>
                </Link>
                <Link to="/residentialPg">
                <button
                  type="button"
                  className={`btn ${formData.basicDetails.service === 'pg' ? 'btn-primary' : 'btn-outline-primary'}`}
                  onClick={() => handleInputChange('basicDetails', 'service', 'pg')}
                >
                  PG/Co-living
                </button>
                </Link>
              </div>
              {errors.service && <small className="text-danger">{errors.service}</small>}
            </div>

            <div className="mb-3">
              <label className="form-label">Address</label>
              <input
                type="text"
                className="form-control"
                value={formData.basicDetails.address}
                onChange={(e) => handleInputChange('basicDetails', 'address', e.target.value)}
              />
              {errors.address && <small className="text-danger">{errors.address}</small>}
            </div>
          </div>
        );
      case 1:
        return (
          <div>
            <div className="mb-3">
              <label className="form-label">Property Type</label>
              <div className="btn-group flex-wrap" role="group" style={{ display: 'flex', flexWrap: 'wrap', gap: '5px' }}>
                <button
                  type="button"
                  className={`btn ${formData.propertyDetails.property_type === 'apartment' ? 'btn-primary' : 'btn-outline-primary'}`}
                  onClick={() => handleInputChange('propertyDetails', 'property_type', 'apartment')}
                >
                  Apartment
                </button>
                <button
                  type="button"
                  className={`btn ${formData.propertyDetails.property_type === 'independent_floor' ? 'btn-primary' : 'btn-outline-primary'}`}
                  onClick={() => handleInputChange('propertyDetails', 'property_type', 'independent_floor')}
                >
                  Independent Floor
                </button>
                <button
                  type="button"
                  className={`btn ${formData.propertyDetails.property_type === 'independent_house' ? 'btn-primary' : 'btn-outline-primary'}`}
                  onClick={() => handleInputChange('propertyDetails', 'property_type', 'independent_house')}
                >
                  Independent House
                </button>
                <button
                  type="button"
                  className={`btn ${formData.propertyDetails.property_type === 'villa' ? 'btn-primary' : 'btn-outline-primary'}`}
                  onClick={() => handleInputChange('propertyDetails', 'property_type', 'villa')}
                >
                  Villa
                </button>
              </div>
              {errors.property_type && <small className="text-danger">{errors.property_type}</small>}
            </div>



            <div className="mb-3">
              <label className="form-label">Building/Project/Society</label>
              <input
                type="text"
                className="form-control"
                value={formData.propertyDetails.building}
                onChange={(e) => handleInputChange('propertyDetails', 'building', e.target.value)}
              />
              {errors.building && <small className="text-danger">{errors.building}</small>}
            </div>

            <div className="mb-3">
              <label className="form-label">Locality</label>
              <input
                type="text"
                className="form-control"
                value={formData.propertyDetails.locality}
                onChange={(e) => handleInputChange('propertyDetails', 'locality', e.target.value)}
              />
              {errors.locality && <small className="text-danger">{errors.locality}</small>}
            </div>

            {formData.propertyDetails.property_type !== 'plot' && (
              <div className="mb-3">
                <label className="form-label">Furnish Type</label>
                <div className="btn-group flex-wrap" role="group" style={{ display: 'flex', flexWrap: 'wrap', gap: '5px' }}>
                  <button
                    type="button"
                    className={`btn ${formData.propertyDetails.furnish_type === 'fully_furnished' ? 'btn-primary' : 'btn-outline-primary'}`}
                    onClick={() => handleInputChange('propertyDetails', 'furnish_type', 'fully_furnished')}
                  >
                    Fully Furnished
                  </button>
                  <button
                    type="button"
                    className={`btn ${formData.propertyDetails.furnish_type === 'semi_furnished' ? 'btn-primary' : 'btn-outline-primary'}`}
                    onClick={() => handleInputChange('propertyDetails', 'furnish_type', 'semi_furnished')}
                  >
                    Semi Furnished
                  </button>
                  <button
                    type="button"
                    className={`btn ${formData.propertyDetails.furnish_type === 'unfurnished' ? 'btn-primary' : 'btn-outline-primary'}`}
                    onClick={() => handleInputChange('propertyDetails', 'furnish_type', 'unfurnished')}
                  >
                    Unfurnished
                  </button>

                </div>
                {errors.furnish_type && <small className="text-danger">{errors.furnish_type}</small>}
              </div>

            )}
            <div className="mb-3">
              <div className="form-check">
                <input
                  type="checkbox"
                  className="form-check-input"
                  id="shareListing"
                  checked={formData.propertyDetails.share_listing || false} // Ensure it's boolean
                  onChange={(e) => handleInputChange('propertyDetails', 'share_listing', e.target.checked)} // Use `checked`
                />
                <label className="form-check-label" htmlFor="shareListing">
                  Share the listing with the agent
                </label>
              </div>
              {errors.share_listing && <small className="text-danger">{errors.share_listing}</small>}
            </div>

            {['independent_floor', 'independent_house', 'villa'].includes(formData.propertyDetails.property_type) && (
              <>
                {/* BHK Section */}
                <div className="mb-3">
                  <label className="form-label">BHK</label>
                  <div
                    className="btn-group flex-wrap"
                    role="group"
                    style={{ display: 'flex', flexWrap: 'wrap', gap: '5px' }}
                  >
                    <button
                      type="button"
                      className={`btn ${formData.propertyDetails.bhk === '1 rk' ? 'btn-primary' : 'btn-outline-primary'
                        }`}
                      onClick={() => handleInputChange('propertyDetails', 'bhk', '1 rk')}
                    >
                      1 RK
                    </button>
                    <button
                      type="button"
                      className={`btn ${formData.propertyDetails.bhk === '1 bhk' ? 'btn-primary' : 'btn-outline-primary'
                        }`}
                      onClick={() => handleInputChange('propertyDetails', 'bhk', '1 bhk')}
                    >
                      1 BHK
                    </button>
                    <button
                      type="button"
                      className={`btn ${formData.propertyDetails.bhk === '1.5 bhk' ? 'btn-primary' : 'btn-outline-primary'
                        }`}
                      onClick={() => handleInputChange('propertyDetails', 'bhk', '1.5 bhk')}
                    >
                      1.5 BHK
                    </button>
                    <button
                      type="button"
                      className={`btn ${formData.propertyDetails.bhk === '2 bhk' ? 'btn-primary' : 'btn-outline-primary'
                        }`}
                      onClick={() => handleInputChange('propertyDetails', 'bhk', '2 bhk')}
                    >
                      2 BHK
                    </button>
                  </div>
                  {errors.bhk && <small className="text-danger">{errors.bhk}</small>}
                </div>

                {/* Built-Up Section */}
                <div className="mb-3">
                  <label className="form-label">Built-Up</label>
                  <input
                    type="text"
                    className="form-control"
                    value={formData.propertyDetails.builtup || ''}
                    onChange={(e) => handleInputChange('propertyDetails', 'builtup', e.target.value)}
                  />
                  {errors.builtup && <small className="text-danger">{errors.builtup}</small>}
                </div>
              </>
            )}

          </div>
        );
      case 2:
        return (
          <div>
            <div className="mb-3">
              <label className="form-label">Monthly Rent</label>
              <input
                type="text"
                className="form-control"
                value={formData.propertyPrice.monthlyRent || ''}
                onChange={(e) => handleInputChange('propertyPrice', 'monthlyRent', e.target.value)}
              />
              {errors.monthlyRent && <small className="text-danger">{errors.monthlyRent}</small>}
            </div>
            <div className="mb-3">
              <label className="form-label">Available Form</label>
              <input
                type="date"
                className="form-control"
                value={formData.propertyPrice.availableForm || ''}
                onChange={(e) => handleInputChange('propertyPrice', 'availableForm', e.target.value)}
              />
              {errors.availableForm && <small className="text-danger">{errors.availableForm}</small>}
            </div>
            <div className="mb-3">
              <label className="form-label">Security Deposit</label>
              <div
                className="btn-group flex-wrap"
                role="group"
                style={{ display: 'flex', flexWrap: 'wrap', gap: '5px' }}
              >
                <button
                  type="button"
                  className={`btn ${formData.propertyPrice.securityDeposit === 'none' ? 'btn-primary' : 'btn-outline-primary'
                    }`}
                  onClick={() => handleInputChange('propertyPrice', 'securityDeposit', 'none')}
                >
                  None
                </button>
                <button
                  type="button"
                  className={`btn ${formData.propertyPrice.securityDeposit === '1 month' ? 'btn-primary' : 'btn-outline-primary'
                    }`}
                  onClick={() => handleInputChange('propertyPrice', 'securityDeposit', '1 month')}
                >
                  1 Month
                </button>
                <button
                  type="button"
                  className={`btn ${formData.propertyPrice.securityDeposit === '2 month' ? 'btn-primary' : 'btn-outline-primary'
                    }`}
                  onClick={() => handleInputChange('propertyPrice', 'securityDeposit', '2 month')}
                >
                  2 Month
                </button>
                <button
                  type="button"
                  className={`btn ${formData.propertyPrice.securityDeposit === 'custom' ? 'btn-primary' : 'btn-outline-primary'
                    }`}
                  onClick={() => handleInputChange('propertyPrice', 'securityDeposit', 'custom')}
                >
                  Custom
                </button>
              </div>
              {errors.securityDeposit && <small className="text-danger">{errors.securityDeposit}</small>}
            </div>
          </div>
        );
      case 3:
        return (
          <div>
             <form onSubmit={handleSubmit}>
            <div className="mb-3">
              <label className="form-label">Review</label>
              <div>
                <p>Review all the entered details:</p>
                <pre>{JSON.stringify(formData, null, 2)}</pre>
                <button type="submit" className="btn btn-success">
                  Submit
                </button>
              </div>
            </div>
            </form>
          </div>
        );
      default:
        return <p>Select a step to continue.</p>;
    }
  };

  return (
    <div className="container mt-5">
      <div className="row">
        <div className="col-md-4">
          <div className="list-group">
            {steps.map((step, index) => (
              <button
                key={index}
                className={`list-group-item ${activeStep === index ? 'active' : ''}`}
                onClick={() => setActiveStep(index)}
              >
                {step}
              </button>
            ))}
          </div>
        </div>

        <div className="col-md-8">
          <div className="card">
            <div className="card-header">{steps[activeStep]}</div>
            <div className="card-body">{renderStepContent(activeStep)}</div>
            <div className="card-footer text-end">
              {activeStep > 0 && (
                <button className="btn btn-secondary me-2" onClick={() => setActiveStep((prev) => prev - 1)}>
                  Previous
                </button>
              )}
              {activeStep < steps.length - 1 ? (
                <button className="btn btn-primary" onClick={handleNextStep}>
                  Next
                </button>
              ) : (
                <button className="btn btn-success" onClick={() => alert("Form submitted successfully!")}>
                  Submit
                </button>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ResidentialRent;
